/*
 * product-card.js
 *
 * Wires up the subscribe / one-time purchase toggle on product cards
 * (snippets/card-product.liquid). Loaded once globally, so it must:
 *   - initialize every [data-card-purchase] on the page, and
 *   - be safe to run again (e.g. after AJAX section re-renders) via a
 *     per-wrapper init flag.
 */
(function () {
  function applyType(wrapper, type) {
    var idInput = wrapper.querySelector('[data-card-id-input]');
    var planInput = wrapper.querySelector('[data-card-plan-input]');
    var labelEl = wrapper.querySelector('[data-card-btn-label]');
    var priceEl = wrapper.querySelector('[data-card-btn-price]');
    var toggleBtns = wrapper.querySelectorAll('[data-card-type]');

    var d = wrapper.dataset;
    var isSub = type === 'subscribe';

    if (idInput) idInput.value = isSub ? d.subId : d.oneId;

    if (planInput) {
      if (isSub && d.subPlan) {
        planInput.value = d.subPlan;
        planInput.name = 'selling_plan';
        planInput.disabled = false;
      } else {
        planInput.value = '';
        planInput.disabled = true;
      }
    }

    if (labelEl) labelEl.textContent = isSub ? (d.subLabel || 'Subscribe') : (d.oneLabel || 'Add to cart');
    if (priceEl) priceEl.textContent = isSub ? (d.subPrice || '') : (d.onePrice || '');

    toggleBtns.forEach(function (btn) {
      var active = btn.getAttribute('data-card-type') === type;
      btn.classList.toggle('is-active', active);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-card-purchase]').forEach(function (wrapper) {
      if (wrapper.__wnCardInit) return;
      wrapper.__wnCardInit = true;

      applyType(wrapper, wrapper.dataset.defaultType || 'subscribe');

      wrapper.querySelectorAll('[data-card-type]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          applyType(wrapper, btn.getAttribute('data-card-type'));
        });
      });
    });
  }

  window.wnInitCardPurchase = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }
})();
